<header
  class="topbar surface-card border-bottom-1 surface-border px-4 py-3 flex align-items-center justify-content-end gap-4">
  <!-- Marca e localização atual -->
  <div class="topbar__context mr-auto">
    <a
      class="topbar__logo-link"
      data-testid="topbar-logo"
      routerLink="/dashboard"
      aria-label="GextorPro - ir para o início">
      <img
        class="topbar__logo"
        src="/images/logo.svg"
        alt="GextorPro" />
      <svg
        class="topbar__logo-mark"
        viewBox="0 0 19 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#2943F0"
          d="M3.54328 0.517441H14.507C16.456 0.517441 18.0503 2.11171 18.0503 4.06072V16.2473C18.0503 18.1963 16.456 19.7906 14.507 19.7906H3.54328C1.59427 19.7906 0 18.1963 0 16.2473V4.06072C0 2.11171 1.59427 0.517441 3.54328 0.517441ZM13.8309 2.99649H9.0314C6.95301 2.99649 5.17094 4.5198 4.50735 6.4563C4.01906 7.87528 4.16096 9.53215 4.89966 10.8343C5.73853 12.3159 7.27854 13.3676 9.0314 13.3676C11.6732 13.3676 13.8309 11.2057 13.8309 8.56808V2.99649ZM5.13338 15.8424L6.59409 14.0896C7.51643 14.8659 8.4346 15.3166 9.35693 15.2206C10.0581 15.1455 11.0013 14.9076 11.4687 13.9477L13.8351 13.9853C13.1256 16.3057 11.3894 17.1738 9.72003 17.299C8.37199 17.3992 6.74434 17.107 5.13755 15.8424H5.13338ZM9.06896 5.2293C10.5297 5.2293 11.6816 6.54394 11.6816 8.18412C11.6816 9.82847 10.5297 11.1807 9.06896 11.1807C7.60825 11.1807 6.49393 9.84933 6.49393 8.20498C6.49393 6.56064 7.60825 5.2293 9.06896 5.2293Z" />
      </svg>
      <span class="topbar__sr-only">GextorPro</span>
    </a>

    @if (breadcrumb(); as crumb) {
      <nav
        class="topbar__breadcrumb"
        aria-label="Você está em"
        data-testid="topbar-breadcrumb">
        <span
          class="topbar__crumb"
          [class.topbar__crumb--current]="!crumb.destination">
          {{ crumb.domain }}
        </span>
        @if (crumb.destination) {
          <lucide-icon
            class="topbar__crumb-separator"
            name="chevron-right"
            [size]="14"
            aria-hidden="true" />
          <span
            class="topbar__crumb topbar__crumb--current"
            aria-current="page">
            {{ crumb.destination }}
          </span>
        }
      </nav>
    }
  </div>

  <div class="topbar__quick-actions">
    <div class="topbar__quick-actions-slot">
      <ng-content />
    </div>
    <app-product-lookup />
  </div>

  <!-- Notifications with Badge -->
  <div class="relative">
    <app-notifications-popover />
  </div>

  <!-- User Info -->
  <a
    class="flex align-items-center gap-3 cursor-pointer no-underline select-none"
    data-testid="topbar-user-menu-trigger"
    (click)="userMenu.toggle($event)">
    <div
      class="topbar__avatar-ring"
      [ngClass]="subscriptionInfo().ringClass"
      [attr.title]="subscriptionInfo().label"
      data-testid="topbar-avatar-ring">
      <div class="topbar__avatar-gap">
        <p-avatar
          [image]="userAvatar"
          shape="circle" />
      </div>
    </div>
    <div class="topbar__user-copy text-left">
      <div class="font-semibold text-color text-sm">{{ userName() }}</div>
      <div class="text-xs text-color-secondary">{{ userEmail() }}</div>
    </div>
  </a>

  <p-menu
    #userMenu
    [model]="userMenuItems()"
    [popup]="true"
    [appendTo]="'body'"
    styleClass="topbar__user-menu w-14rem p-1 bg-white border-1 surface-border shadow-2 border-round-md">
    <ng-template
      pTemplate="item"
      let-item>
      @if (item.routerLink) {
      <a
        pRipple
        class="flex align-items-center p-menuitem-link gap-2 px-3 py-2 cursor-pointer transition-colors transition-duration-150 hover:surface-100 border-round-sm"
        [routerLink]="item.routerLink"
        [attr.data-testid]="'topbar-menu-' + item.icon"
        [queryParams]="item.queryParams">
        <span class="topbar__menu-icon flex align-items-center justify-content-center p-0 m-0">
          <i-lucide
            [name]="item.icon"
            [size]="16"
            class="flex align-items-center justify-content-center p-0 m-0 text-color-secondary"></i-lucide>
        </span>
        <span class="text-color text-sm font-medium flex-1 p-0 m-0">{{ item.label }}</span>
      </a>
      } @else if (item.id === 'help-tour') {
      <a
        pRipple
        class="flex align-items-center p-menuitem-link gap-2 px-3 py-2 cursor-pointer transition-colors transition-duration-150 hover:surface-100 border-round-sm"
        data-testid="topbar-menu-help-tour"
        role="button"
        tabindex="0"
        (click)="item.command($event)"
        (keydown.enter)="item.command($event)">
        <span class="topbar__menu-icon flex align-items-center justify-content-center p-0 m-0">
          <i-lucide
            [name]="item.icon"
            [size]="16"
            class="flex align-items-center justify-content-center p-0 m-0 text-color-secondary"></i-lucide>
        </span>
        <span class="text-color text-sm font-medium flex-1 p-0 m-0">{{ item.label }}</span>
      </a>
      } @else if (item.command) {
      <a
        pRipple
        class="flex align-items-center p-menuitem-link gap-2 px-3 py-2 cursor-pointer transition-colors transition-duration-150 hover:bg-red-50 border-round-sm logout-item"
        data-testid="topbar-menu-logout"
        role="button"
        tabindex="0"
        (click)="item.command($event)">
        <span class="topbar__menu-icon flex align-items-center justify-content-center p-0 m-0">
          <i-lucide
            [name]="item.icon"
            [size]="16"
            class="flex align-items-center justify-content-center p-0 m-0 text-red-500"></i-lucide>
        </span>
        <span class="text-red-500 text-sm font-medium flex-1 p-0 m-0">{{ item.label }}</span>
      </a>
      }
    </ng-template>
  </p-menu>
</header>
